import { Box, Flex } from 'components/box';
import { Heading, Text } from 'components/typography';
import Button from 'components/button';
import { css } from '@emotion/react';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const NotReturnableModal = ({
  close,
  confirm,
  isOpen,
  isReturnable,
}: {
  close: () => void;
  confirm: () => void;
  isOpen: boolean;
  isReturnable: boolean;
}) => {
  if (isReturnable) {
    return null;
  }

  return (
    <Modal
      title="This item can't be returned"
      close={close}
      isOpen={isOpen}
      size="small"
    >
      <Box
        p={5}
        css={css`
          position: relative;
        `}
      >
        <Flex mt={4} mb={4} justifyContent="center">
          <Heading fontSize={['l', null, 'x2l']}>
            This item can&apos;t be returned
          </Heading>
        </Flex>
        <Text
          mx={[0, null, 5]}
          css={theme => css`
            font-size: ${theme.fontSizes[3]};
            line-height: 1.5em;
            color: ${theme.colors.darkGrey};
          `}
        >
          Due to the nature of this product, it may not be refunded or
          exchanged, so please take care when making your selection.
        </Text>
        <Flex
          mt={5}
          justifyContent="space-evenly"
          flexDirection={['column', null, 'row']}
        >
          <Button
            onClick={close}
            width="100%"
            variant="outlined"
            mr={[0, null, 4]}
            mb={[3, null, 0]}
          >
            Cancel
          </Button>
          <Button id="confirm-add-to-cart" onClick={confirm} width="100%">
            Add it to my cart
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};

export default NotReturnableModal;
